document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form')
  const submit = () => form.submit()
  document.querySelector('[name="type"]').addEventListener('change', submit)
  document.querySelector('[name="classification"]').addEventListener('change', submit)
})
